import { isDateInPast } from '@eventr/common'
import {
    IDrawerStore,
    StyledPullToRefresh,
    useDrawerStore,
} from '@eventr/common-storybook'
import { Box, Stack } from '@mui/material'
import { useEffect, useMemo } from 'react'
import { useShallow } from 'zustand/react/shallow'
import { isConnectivityAvailable } from '../../feat/connectivity/connectivityListener'
import { useGlobalRouter } from '../../feat/globalRouter/useGlobalRouter'
import { navBarRef } from '../../feat/layout/navBar'
import { Paths } from '../../routes'
import { bs, useBoundStore } from '../../state/bound.store'
import { useRouteGuardContext } from '../../state/routeGuardProvider'
import { keyboardState } from '../../state/windowState/windowSignals'
import { RendererSplitterTeams } from '../../v2/rendererSplitterTeams'
import { BottomPageFab } from '../components/bottomFab'
import { SearchBar } from '../components/carousel/slide/footer/HeaderSearchBar'
import { TeamMembers } from './TeamMembers'
import { EmptyItineraryInstructionsTeam } from './teamPageInstructions/emptyItinerary'
import { NoItinerariesInstrunctionsTeam } from './teamPageInstructions/noItineraries'

export const TeamPage = () => {
    const {
        selectedItinerary,
        noItineraries,
        selectedItineraryUsers,
        eventEnded,
        checkIfAllDynamicSectionsEmpty,
    } = useBoundStore(
        useShallow((s) => {
            return {
                selectedItinerary: s.selectedItinerary,
                noItineraries: s.noItineraries,
                selectedItineraryUsers: s.selectedItineraryUsers,
                eventEnded: s.eventEnded,
                checkIfAllDynamicSectionsEmpty:
                    s.checkIfAllDynamicSectionsEmpty,
            }
        })
    )
    const { pushPath } = useGlobalRouter()

    const { isAllowed } = useRouteGuardContext()
    const { drawerOpenState } = useDrawerStore(
        useShallow((s: IDrawerStore) => ({ drawerOpenState: s.openState }))
    )

    const content = useMemo(() => {
        if (checkIfAllDynamicSectionsEmpty()) return null
        return <RendererSplitterTeams v2Data={selectedItinerary?.v2 ?? []} />
    }, [checkIfAllDynamicSectionsEmpty, selectedItinerary])

    useEffect(() => {
        bs().setOverride(null)
        bs().setPast(false)
    }, [])

    return (
        <>
            <div>
                <StyledPullToRefresh
                    onRefresh={async () => {
                        /// Nothing
                    }}
                    promiseFunction={async () => {
                        useBoundStore.setState({ refreshKey: Math.random() })
                        await bs().getProfile()
                        await bs().fetchUsers()
                        await bs().forceItineraryMapUpdate()
                        await bs().fetchOrgConfig()
                    }}
                    maxPullDownDistance={100}
                >
                    {noItineraries ? (
                        <NoItinerariesInstrunctionsTeam />
                    ) : (
                        <>
                            <div style={{ padding: '0px 0px 128px 0px' }}>
                                {!checkIfAllDynamicSectionsEmpty() && (
                                    <Box padding={'0px 8px'}>
                                        <SearchBar
                                            value=""
                                            onChange={() => {}}
                                            onClick={() => {
                                                pushPath(Paths.teamSearch, {
                                                    animation: 'right',
                                                })
                                            }}
                                        />
                                    </Box>
                                )}
                                {selectedItineraryUsers()?.length > 1 && (
                                    <TeamMembers
                                        users={selectedItineraryUsers()}
                                    />
                                )}
                                {selectedItinerary &&
                                    checkIfAllDynamicSectionsEmpty() &&
                                    selectedItineraryUsers()?.length <= 1 && (
                                        <EmptyItineraryInstructionsTeam />
                                    )}
                                {content}
                            </div>
                        </>
                    )}
                </StyledPullToRefresh>
                <>
                    {isAllowed(['allowedInviteUsers']) &&
                        !eventEnded &&
                        !drawerOpenState && (
                            <Stack
                                flexDirection="row"
                                alignItems="flex-end"
                                gap="8px"
                                style={{
                                    position: 'fixed',
                                    bottom:
                                        30 +
                                        (navBarRef.value?.current
                                            ?.clientHeight ?? 0) +
                                        'px',
                                    right: '16px',
                                    padding: '0',
                                    zIndex: '1',
                                }}
                            >
                                {keyboardState.value.openState === 'didHide' &&
                                    !noItineraries && (
                                        <BottomPageFab
                                            id="addUserButton"
                                            onClick={() => {
                                                window.pushPath(
                                                    `/setup/add-users`
                                                )
                                            }}
                                            disabled={
                                                !isConnectivityAvailable.value
                                            }
                                            icon="Add_User"
                                            highlight={
                                                selectedItinerary &&
                                                !isDateInPast(
                                                    selectedItinerary?.v2?.[0]
                                                        .data.end_date
                                                ) &&
                                                checkIfAllDynamicSectionsEmpty() &&
                                                selectedItineraryUsers()
                                                    .length <= 1
                                            }
                                        />
                                    )}
                            </Stack>
                        )}
                </>
            </div>
        </>
    )
}
